import { Smartphone } from 'lucide-react';
import { useI18n } from '../i18n/I18nProvider';
import { mobileAppDownload, mobileApps } from '../config/mobileApps';
import { Button, Modal } from './index';
import styles from './mobileOnly.module.css';

export function MobileOnlyModal({ onClose, feature }: { onClose: () => void; feature?: string }) {
  const { t } = useI18n();
  return <Modal title={t('Tính năng trên điện thoại')} onClose={onClose} className={styles.dialog}>
    <div className={styles.notice}>
      <span className={styles.icon}><Smartphone size={25} aria-hidden="true" /></span>
      <div>{feature && <small>{feature}</small>}<p>{t('Hiện tại tính năng này chỉ có trên điện thoại.')}</p></div>
    </div>
    <p className={styles.instruction}>{t('Tải Store-X trên Google Play hoặc App Store bằng mã QR bên dưới.')}</p>
    <a href={mobileAppDownload.url} target="_blank" rel="noopener noreferrer" className={styles.qr} aria-label={t('Tải Store-X trên Google Play hoặc App Store bằng mã QR bên dưới.')}>
      <img src={mobileAppDownload.qr} width="200" height="200" alt="Store-X · Google Play / App Store" />
      <span>Google Play · App Store</span>
    </a>
    <div className={styles.stores}>
      <a href={mobileApps.googlePlay.url} target="_blank" rel="noopener noreferrer" className={styles.store}>
        <span>{t('Tải trên Google Play')}</span>
      </a>
      <a href={mobileApps.appStore.url} target="_blank" rel="noopener noreferrer" className={styles.store}>
        <span>{t('Tải trên App Store')}</span>
      </a>
    </div>
    <div className="form-actions"><Button type="button" onClick={onClose}>{t('Đóng')}</Button></div>
  </Modal>;
}
